import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function ProfitLoss() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState([]);
    const fetchProfitLoss = () => {
        const start = startDate
            ? startDate.toISOString().substring(0, 10)
            : '';
        const end = endDate
            ? endDate.toISOString().substring(0, 10)
            : '';
        axios.get(`${baseUrl}profit-loss/?start=${start}&end=${end}`)
            .then(res => {
                const rows = [
                    {
                        id: 1,
                        type: 'Total Revenue',
                        amount: res.data.total_revenue
                    },
                    {
                        id: 2,
                        type: 'Total Expense',
                        amount: res.data.total_expense
                    },
                    {
                        id: 3,
                        type: 'Net Profit',
                        amount: res.data.net_profit
                    }
                ];
                setData(rows);
            })
            .catch(err => console.log(err));
    };
    useEffect(() => {
        fetchProfitLoss();
    }, [startDate, endDate]);
    const columns = [
        {
            field: 'type',
            headerName: 'Description',
            width: 300
        },
        {
            field: 'amount',
            headerName: 'Amount',
            width: 200
        },
    ];
    return (
        <section className='container mt-4'>

            <h3 className='bg-dark text-white text-center p-2'>
                Profit & Loss
            </h3>

            <div className="row mb-3">

                <div className="col-md-3">
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="From Date"
                        className="form-control"
                    />
                </div>

                <div className="col-md-3">
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="To Date"
                        className="form-control"
                    />
                </div>

            </div>

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid
                    className="mt-4"

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}

                    rows={data}
                    columns={columns}
                    autoHeight
                    pageSize={10}

                    slots={{
                        toolbar: GridToolbar,
                    }}
                />

            </div>

        </section>
    )
}
export default ProfitLoss;